import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {ApsServiceService} from '../aps-service.service'

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {
  loaderdata:any=false
  getusername:any=localStorage.getItem('username');
  getpassword:any=localStorage.getItem('password');
  getplanname:any = localStorage.getItem('planname');
  getplanyear:any = localStorage.getItem('planyear');
  getplanamount:any = localStorage.getItem('planamount');
  isLogsActive:boolean=true;
  isaccept:boolean=false
  checkvalue:any=0;
  pusherror:boolean=false
  errormessage:any='';
  userid:any;
  userdata:any={}
  planinfo: string;
  checkpaymentstatus: any;
  constructor(private router: Router,private searchitem: ApsServiceService,private toastr: ToastrService,private activatedRoute: ActivatedRoute) { }
  validateEmails = (email) => {

    return email.toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    }
  ngOnInit(): void {
   ////console.log(localStorage.getItem("planinfo"))

    this.getparams()


    this.planinfo=localStorage.getItem('planinfo')
    //console.log(this.getusername)
    if(!this.getusername && !this.getpassword){
      this.router.navigate(['/']);

    }
       this.getusername=localStorage.getItem('username');
  this.getpassword=localStorage.getItem('password');
    
  }

  closenotif(){
    this.errormessage='';
    this.pusherror=false
  }

  regelement(){
    this.router.navigate(['/']);

  }
  getaccept(data){
    if(this.isaccept){
      this.isaccept=false
      //console.log("false")
    }else {
      this.isaccept=true
      //console.log("true")

    }
   

  }


  onClickSubmit(data){
    this.pusherror=false
      this.errormessage='';
    if(!this.isaccept){
      this.pusherror=true
      this.toastr.warning('Please accept terms and conditions!..')

    }else{
    //console.log(data)
    if(data.Firstname == '' || !data.Firstname || data.lastName == '' || !data.lastName || data.address1 == '' || !data.address1 || data.Phone == '' || !data.Phone || data.city == '' || !data.city || data.email == '' || !data.email || data.state == '' || !data.state || data.Country == '' || !data.Country || data.zip == '' || !data.zip   ){
  
      this.pusherror=true
      this.toastr.error(' Please enter all required information')
    }else{
      //console.log(data)
      this.loaderdata=true
      this.searchitem.CheckUseremail(data.email).subscribe((responces)=>{
        if(responces.status){

          this.searchitem.Getusername(this.getusername).subscribe((responce) => {
            if(responce.status){

              this.searchitem.regUserData(data,this.getusername,this.getpassword,this.getplanyear,this.getplanname,this.getplanamount).subscribe((responce) => {
                if(responce.status==true){
        
                  this.userid=responce.userid
                 
              
                  this.setUserPayment();
        
                  // this.addSubscription(this.userid)
                  localStorage.setItem("userid", this.userid);
               
                }else{
                  this.loaderdata=false
                  this.toastr.warning('', responce.msg);
              
        
                }
                //console.log(responce)
              })
            }else{
              this.loaderdata=false
              this.toastr.error('Username Already Exists!')
            }

          })

    
    }else{
      this.toastr.error('Email Already Exists!')
      this.loaderdata=false
    }
    })
      
    }
  }

  }
  setUserPayment(){
    var planamount=localStorage.getItem('planamount');
    var planyear=localStorage.getItem('planyear');
    var planname=localStorage.getItem('planname');
    var userid=localStorage.getItem('userid');
    var donation=localStorage.getItem('Donation');
    if(donation){
      var total=parseFloat(planamount) + parseFloat(donation)  
    }else{
      var total=parseFloat(planamount) 
    }
    
    //console.log(total)

    var payloader=[]
  
  
      var dataset={}
      dataset["name"]=planname
      dataset["sku"]=1
      dataset["price"]= total
      dataset["currency"]="USD"
      dataset["quantity"]=1
      payloader.push(dataset)
    
    var itemss=parseFloat(localStorage.getItem("totalCart"));
    localStorage.setItem('storedcart',JSON.stringify(payloader))
    
    var payments={
      "currency": "USD",
      "total": total
    }
    //console.log(payments)
    //   [{
    //     "name": "Red Sox Hat",
    //     "sku": "001",
    //     "price": "5.00",
    //     "currency": "USD",
    //     "quantity": 1
    // }]
    //console.log(payloader)
      this.searchitem.regPayment(payments,payloader).subscribe((responce)=>{
      //console.log(responce.data)
      this.loaderdata=false
      localStorage.setItem("shoppaymets","true")
      window.location.href=responce.data;
    
      // this.routerItem.navigate([responce.data])
      
    
      })
  }



  getparams(){
    if( this.activatedRoute.snapshot.params.payment){
    this.checkpaymentstatus = this.activatedRoute.snapshot.params.payment;
    //console.log(this.activatedRoute.snapshot.params)
    //console.log(this.checkpaymentstatus)
    var planamount=localStorage.getItem('planamount');
    var donations=localStorage.getItem('Donation');
    if(!donations || donations == " " ){
      //console.log("null")
      var donation=0;
    }else{
      //console.log("not null")
     var donation = parseFloat(localStorage.getItem('Donation'));
    }


    var total=parseFloat(planamount) + Number(donation) // change to normal
    // console.log(total)
    // console.log(total)
    if(this.checkpaymentstatus=="success"){
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      //console.log(params);
      
      var itemss=parseFloat(localStorage.getItem("totalCart"));
var payments={
  "currency": "USD",
  "total": total
}

this.searchitem.paymentSuccessreg(payments,params).subscribe((responce) => {
  if(responce.status){

    //console.log(responce)
   
    this.addSubscription()


}else{
  this.toastr.error('Please Login again..','Payment not processed')
  localStorage.clear();
  this.router.navigate(["/"])


}

})
      
    });



  }else     if(this.checkpaymentstatus=="cancel"){
    this.loaderdata=false;
    this.toastr.error('Please Login..','Payment not processed')
    localStorage.clear();
    this.router.navigate(["/"])
  }
}


  }




  addSubscription(){
    //console.log('reg');

    this.loaderdata=true

    var planamount=localStorage.getItem('planamount');
    var planyear=localStorage.getItem('planyear');
    var planname=localStorage.getItem('planname');
    var userid=localStorage.getItem('userid');
    // var donation=localStorage.getItem('Donation');
    if(!localStorage.getItem('Donation') || localStorage.getItem('Donation') == " " ){
      //console.log("null")
      var donation=0;
    }else{
      //console.log("not null")
     var donation = parseFloat(localStorage.getItem('Donation'));
    }
    this.userdata={}
    this.userdata= {
      "userid":userid,
      "planyear":planyear,
      "planname":planname,
      "planamount":planamount,
      "donations":donation
  
  }
    this.searchitem.subscription(this.userdata).subscribe((responce) => {
      //console.log("subscription")
      //console.log(responce)
      if(responce.status){
      
        // alert("Registration completed successfully")
        this.loaderdata=false
        // window.location.reload();
        localStorage.clear();
        this.router.navigate(['/']);
        this.toastr.success('',"Registration Completed Successfully");
        
      }else{
        this.toastr.error('Oops.. Something Error in Subscription');
        this.loaderdata=false
        // window.location.reload();
        localStorage.clear();
        this.router.navigate(['/']);

      }
    })

  }
  // checkEmail(){
  //   //console.log(this.form.controls['email'].value)
  //   var checkmail=this.form.controls['email'].value
  //   this.searchitems.CheckUseremail(checkmail).subscribe((responces)=>{
  //     //console.log(responces)
  //     if(responces.status){
  //       this.checkuseremail=false
  //     }else{
  //       this.checkuseremail=true
  //     }
      

  //   })

  // }

}
